import React from 'react';
import styled from 'styled-components';

import { Catalog } from '@/types/Catalog';

import ReviewedPageComments from './ReviewedPageComments';
import ReviewedPageHeader from './ReviewedPageHeader';
import ReviewedPageRatings from './ReviewedPageRatings';

type Props = {
    baseUrl: string;
    catalog: Catalog;
    completedReview: any;
    items: any[];
    reviewComments: any;
    seller: any;
};

const ReviewedPage = (props: Props) => {
    const { baseUrl, catalog, completedReview, items, reviewComments, seller } = props;

    return (
        <Container>
            <ReviewedPageHeader
                baseUrl={baseUrl}
                catalog={catalog}
                completedReview={completedReview}
                items={items}
            />
            <ReviewedPageRatings completedReview={completedReview} />
            <ReviewedPageComments
                completedReview={completedReview}
                reviewComments={reviewComments}
                seller={seller}
            />
        </Container>
    );
};

export default ReviewedPage;

const Container = styled.div`
    max-width: ${({ theme }) => theme.breakpoints.pageWidth};
    margin: 0 auto;
    padding: 0 20px 30px;
`;
